import React from 'react';
import ReactDOM from 'react-dom';
import { AnimatePresence } from 'framer-motion';
import animations from '../../helpers/animations';
import {
    BackgroundModal,
    ModalWrapper,
    ModalContent,
    CloseModalButton,
    ImageWrap,
} from './styles';

type Props = {
    isVisible: boolean;
    setVisible: (d: boolean) => void;
    imageSrc: string;
    alt?: string;
};

export const ImageBanner: React.FC<Props> = ({
    isVisible,
    setVisible,
    imageSrc,
    alt,
}) => {
    return ReactDOM.createPortal(
        <AnimatePresence>
            {isVisible && (
                <BackgroundModal onClick={() => setVisible(false)} {...animations.fadeInOut(0.1)}>
                    <ModalWrapper onClick={e => e.stopPropagation()}>
                        <CloseModalButton onClick={() => setVisible(false)} />

                        <ModalContent>
                            <ImageWrap>
                                <img src={imageSrc} alt={alt ?? 'banner'} />
                            </ImageWrap>
                        </ModalContent>
                    </ModalWrapper>
                </BackgroundModal>
            )}
        </AnimatePresence>,
        document.body
    );
};
